import { useEffect, useState } from 'react';
import { AiOutlineArrowUp } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';

export const Scrollup = () => {
    const { t } = useTranslation();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY >= 560);
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return (
    <a href="#home" className={visible ? 'scrollup show-scroll' : 'scrollup'} id="back-to-top" aria-label={t('back_to_top')}>
        <AiOutlineArrowUp aria-hidden="true" />
    </a>
    )
}